import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { InputDate } from '@/components/_common';
import moment from 'moment';
import { DateTimeFormat } from '@/utils/moment';
import { ListInformativeQuery } from '@/core/domain/notification/Informative/Informative.types';

function InformativeExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListInformativeQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={8} lg={4} xxl={4}>
        <InputDate
          placeholder={intl.formatMessage({
            id: 'informative.list.header.date',
          })}
          value={
            queryParams?.informationDate
              ? moment(queryParams?.informationDate)
              : undefined
          }
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              informationDate: value?.format(DateTimeFormat),
            }))
          }
        />
      </Col>

      <Col span={24} md={8} lg={8} xxl={8}>
        <Input
          value={queryParams?.employeeName}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, employeeName: value }))
          }
          placeholder={intl.formatMessage({
            id: 'informative.list.header.creator',
          })}
        />
      </Col>

      <Col span={24} md={8} lg={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default InformativeExtraFilters;
